import { BulkClosedForArrivalValidation } from 'uplisting-frontend/validations/bulk-closed-for-arrival';

export const BulkClosedForDepartureValidation = BulkClosedForArrivalValidation;
